import { render, staticRenderFns } from "./CustomHead.vue?vue&type=template&id=e54b558e&scoped=true"
import script from "./CustomHead.vue?vue&type=script&lang=js"
export * from "./CustomHead.vue?vue&type=script&lang=js"
import style0 from "./CustomHead.vue?vue&type=style&index=0&id=e54b558e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54b558e",
  null
  
)

export default component.exports